/**
 * @generated SignedSource<<d3a5e2872db5c9e5f42dcf46fffb155b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeIsAuthorized"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "request"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentedByCurrentUser",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "createVibePost",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "media",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spam",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "likesCount",
        "storageKey": null
      },
      {
        "condition": "includeIsAuthorized",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likedByCurrentUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stemLikedByCurrentUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewedByCurrentUser",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quotedByCurrentUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharedByCurrentUser",
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stemLikesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "viewsCount",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quotesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sharesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePoll",
        "kind": "LinkedField",
        "name": "poll",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "options",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "optionVotesCounts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pollVotesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votedByCurrentUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votedOptionIndex",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Vibe",
            "kind": "LinkedField",
            "name": "vibe",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createCommentFormCreateCommentMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createCommentFormCreateCommentMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "0654bcc219e65e6fdeb62bb1f8bd4f87",
    "id": null,
    "metadata": {},
    "name": "createCommentFormCreateCommentMutation",
    "operationKind": "mutation",
    "text": "mutation createCommentFormCreateCommentMutation(\n  $request: CreateVibePostRequestInput!\n  $includeIsAuthorized: Boolean!\n) {\n  createVibePost(request: $request) {\n    id\n    message\n    created\n    media\n    removed\n    spam\n    likesCount\n    likedByCurrentUser @include(if: $includeIsAuthorized)\n    stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n    viewedByCurrentUser @include(if: $includeIsAuthorized)\n    commentedByCurrentUser @include(if: $includeIsAuthorized)\n    quotedByCurrentUser @include(if: $includeIsAuthorized)\n    sharedByCurrentUser @include(if: $includeIsAuthorized)\n    stemLikesCount\n    viewsCount\n    commentsCount\n    quotesCount\n    sharesCount\n    poll {\n      id\n      options\n      optionVotesCounts\n      pollVotesCount\n      votedByCurrentUser\n      votedOptionIndex\n    }\n    parent {\n      id\n      commentsCount\n      commentedByCurrentUser\n    }\n    author {\n      id\n      vibe {\n        username\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "185deba441a4c4e8faa0d541a62646ac";

module.exports = node;
